import Tooltip from '@mui/material/Tooltip';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { Box } from '@mui/material';

const InfoTooltipIcon = ({ title }) => (
  <Box className="non-printable">
    <Tooltip
      title={title}
      fontSize={22}
      placement="right"
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            fontSize: '1em',
          },
        },
      }}
    >
      <InfoRoundedIcon
        fontSize="small"
        sx={{
          color: '#9D9D9C',
          ml: 1,
        }}
      />
    </Tooltip>
  </Box>
);

export default InfoTooltipIcon;
